import {
  withStyles,
  Divider,
  Grid,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import styles from "../styles";

const RadioGroupComponent = ({
  name,
  value,
  onChange,
  errorInfo,
  label,
  classes,
  options = [],
}) => {
  return (
    <>
      <Divider className={classes.divider} />
      <Grid item xs={12} className={classes.radioHeader}>
        {label}
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label={name}
            name={name}
            value={value}
            classes={{
              root: classes.radioGroup,
            }}
            onChange={onChange}
            column
          >
            {options.map((option) => (
              <FormControlLabel
                value={option.value.toString()}
                key={option.key}
                control={
                  <Radio
                    color="primary"
                    classes={{
                      root: classes.radio,
                      disabled: classes.radioDisabled,
                    }}
                    checked={value == option.value.toString()}
                  />
                }
                label={option.label}
                classes={{
                  label:
                    name === "deliveryWindow"
                      ? classes.windowLabel
                      : classes.radioLabel,
                  disabled: classes.radioDisabled,
                }}
              />
            ))}
          </RadioGroup>
          {errorInfo?.[name] && (
            <div className={classes.errorColor}>{errorInfo[name]}</div>
          )}
        </FormControl>
      </Grid>
    </>
  );
};

export default withStyles(styles)(RadioGroupComponent);